// Role Management API Service - Backend Integration (User-Role Assignments)
import { apiGet, apiPost, apiPut, apiDelete } from '../services/apiClient';

// Helper to wrap response in { data: ... } format for backward compatibility with axios-style responses
const wrapResponse = (data) => ({ data });

export const getUserRoles = async (userId) => {
  const response = await apiGet(`/api/auth/organization/users/${userId}/roles`);
  return wrapResponse(response);
};

// hd-registration RoleController. /api/auth/... 404s at the gateway; same prefix as getUsersWithRole.
const userRolesPath = (userId) =>
  `/gateway/registration/api/signup/organization/users/${userId}/roles`;

export const assignRole = async (userId, roleId) => {
  const response = await apiPost(userRolesPath(userId), { userId, roleId });
  return wrapResponse(response);
};

export const removeRole = async (userId, roleId) => {
  const response = await apiDelete(`${userRolesPath(userId)}/${roleId}`);
  return wrapResponse(response);
};

export const updateRoleAssignment = async (userId, roleId, data) => {
  const response = await apiPut(`/api/auth/organization/users/${userId}/roles/${roleId}`, data);
  return wrapResponse(response);
};

// hd-registration serves this (context-path /registration); the gateway only routes
// /gateway/registration/**, so the /api/auth/... form 404s at the gateway.
export const getUsersWithRole = async (roleId) => {
  const response = await apiGet(`/gateway/registration/api/signup/organization/roles/${roleId}/users`);
  return wrapResponse(response);
};

export const bulkAssignRoles = async (userId, roleIds) => {
  const response = await apiPost(`/api/auth/organization/users/${userId}/roles/bulk`, { roleIds });
  return wrapResponse(response);
};

// Default export for backward compatibility
const roleManagementService = {
  getUserRoles,
  assignRole,
  removeRole,
  updateRoleAssignment,
  getUsersWithRole,
  bulkAssignRoles,
};

export default roleManagementService;
